import { Injectable, inject } from '@angular/core';
import { I18nNamespaceLoader } from '@core/i18n/i18n-namespace.loader';
import { AdminSidePanelService } from '@shared/utils/admin-side-panel.service';
import { PosTxRow } from '../models/pos-transacciones.models';
import {
  PosHubOrderDetailSheetComponent,
  PosHubOrderDetailSheetData,
} from '../presentation/pages/pos-hub-order-detail/pos-hub-order-detail-sheet.component';

/**
 * Abre el sheet de detalle de pedido (misma UI que Pedidos → Completados).
 * Válido con o sin módulo POS (`assert_order_management` vía SalesOrders).
 */
@Injectable({ providedIn: 'root' })
export class PosOrderTxDetailOpenerService {
  private readonly sidePanel = inject(AdminSidePanelService);
  private readonly i18nNamespaces = inject(I18nNamespaceLoader);

  openByOrderId(orderId: string): void {
    const id = orderId.trim();
    if (!id) {
      return;
    }

    this.i18nNamespaces.ensure(['pos', 'sales']).subscribe({
      next: () => this.openSheet(id),
      error: () => this.openSheet(id),
    });
  }

  /** Cuando ya se tiene el `PosTxRow` (lista de Transacciones POS). */
  openRow(row: PosTxRow): void {
    this.openByOrderId(row.id);
  }

  private openSheet(orderId: string): void {
    this.sidePanel.open<
      PosHubOrderDetailSheetComponent,
      PosHubOrderDetailSheetData,
      void
    >(PosHubOrderDetailSheetComponent, {
      data: { orderId },
      width: 'default',
      suppressSaveBar: true,
    });
  }
}
